module.exports = require("./haw.js");